import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonHelperUtils } from '@shared/helper';
import { DialogService } from '@shared/service';
import { DialogConfigInterface } from '@shared/module/dialog/model';
import { ImportService } from '@shared/module/forms/component';

@Component({
  selector: 'app-form-import-file',
  templateUrl: './form-import-file.component.html',
  styleUrls: ['./form-import-file.component.scss'],
})
export class FormImportFileComponent implements OnInit, OnChanges {
  @Input() toggleShow: boolean = false;
  @Input() width: number = 600;
  @Input() height: number = 400;
  @Input() format: string = '';
  @Input() title: string = 'import.title';
  @Input() entity!: string;
  @Output() reload = new EventEmitter<any>();
  @ViewChild('file') input: ElementRef<HTMLInputElement> | undefined;

  dialogConfigs: string[] = [];
  importedFiles: any;
  isOpen: boolean = false;
  loading: boolean = false;

  data: any[] = [];

  constructor(
    public dialogService: DialogService,
    private importService: ImportService
  ) {}

  ngOnInit(): void {
    this.dialogConfigs = [CommonHelperUtils.generateUUID()];
    this.dialogService.addDialog(this.dialogConfigs[0], this.title);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isOpen != this.toggleShow) {
      this.isOpen = !this.isOpen;
      this.open(0);
      this.onFileSelected(false);
    } else {
      this.close(0);
    }
  }

  onFileSelected(event: any): void {
    let files: FileList | File[] | null = null;

    // Drag & drop natif (FileList)
    if (event instanceof FileList) {
      files = event;
    }
    // Drag & drop custom (Array<File>)
    else if (Array.isArray(event) && event.length && event[0] instanceof File) {
      files = event;
    }
    // Input file classique (event DOM)
    else if (event && event.target && event.target.files) {
      files = event.target.files;
    }

    if (files && files.length > 0) {
      if (files.length !== 1) throw new Error('Cannot use multiple files');
      this.importedFiles = Array.from(files);
    } else {
      this.importedFiles = false;
      if (this.input) {
        this.input.nativeElement.value = '';
      }
    }
  }

  open(index: number): void {
    this.dialogService.toggleShow(this.dialogConfigs[index], true);
  }

  close(index: number): void {
    this.dialogService.toggleShow(this.dialogConfigs[index], false);
  }

  getConfig(index: string): DialogConfigInterface | undefined {
    const configs = this.dialogService.dialogConfigs$.getValue();
    return configs.find((d: DialogConfigInterface) => d.id === index);
  }

  onClickImport(): void {
    this.loading = true;
    let file: File = this.importedFiles[0];
    this.importService.importFile(this.entity, file).subscribe(() => {
      this.close(0);
      this.loading = false;
      this.reload.emit();
    });
  }
}
